import React from "react";
import { useEffect, useState } from "react";
import { Form, Link } from "react-router-dom";
import icons from "../../assets/images/sprite-other-icons.svg";
import logoHeader from "../../assets/images/logo-header.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleSignIn, setErrorMessage } from "./cl_SignInSlice";
import { setMobileNumber } from "../resetpage/cl_ResetSlice";

function SignIn() {
  const [mobileNumber, setMobileNumbers] = useState("");
  const navigate = useNavigate();
  const { errorMessage, signInSuccess, isLoading } = useSelector(
    (state) => state.signIn
  );
  const userDetails = useSelector((state) => state.signIn.userDetails);
  const [numberLength, setNumberLength] = useState(false);
  const [pinNumber, setpinNumber] = useState("");
  const [pinError, setpinError] = useState("");
  const [mobileError, setmobileError] = useState("");
  const [hidePassword, setHidePassword] = useState(true);
  const dispatch = useDispatch();
  const numRegex = /^[0-9]+$/;

  const handleMobileChange = (event) => {
    const number = event.target.value;
    if (numRegex.test(number) || number === "") {
      setMobileNumbers(number);
      setmobileError("");
      dispatch(setErrorMessage(""));
    }
  };
  const handlePinChange = (event) => {
    const number = event.target.value;
    dispatch(setErrorMessage(""));
    if (numRegex.test(number) || number === "") {
      if (number.length <= 4) {
        setpinNumber(number);
        setpinError("");
      }
    }
  };
  const handleHidePaswword = () => {
    setHidePassword(!hidePassword);
  };
  const handleLoginSubmit = () => {
    if (isLoading) return;

    if (mobileNumber.length < 9) {
      setmobileError("Please enter a valid 9 digit Mobile Number");
    } else if (
      numberLength &&
      mobileNumber?.charAt(1) !== "7" &&
      mobileNumber?.charAt(1) !== "1"
    ) {
      setmobileError("Please enter a valid 9-digit Mobile Number");
    } else if (
      !numberLength &&
      mobileNumber?.charAt(0) !== "7" &&
      mobileNumber?.charAt(0) !== "1"
    ) {
      setmobileError("Please enter a valid 9-digit Mobile Number");
    } else if (pinNumber.length < 4) {
      setpinError("Please enter a Valid 4 Digit PIN");
    } else {
      dispatch(handleSignIn(mobileNumber, pinNumber, navigate));
    }
    if (pinNumber.length < 4) {
      setpinError("Please enter a Valid 4 Digit PIN");
    }
  };
  function avoidCharacter(e) {
    const re = /[0-9]+/g;
    if (!re.test(e.key)) {
      e.persist();
      e.preventDefault();
    }
  }
  useEffect(() => {
    if (mobileNumber?.charAt(0) == "0") {
      setNumberLength(true);
    } else {
      setNumberLength(false);
    }
  }, [mobileNumber]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      !isLoading && handleLoginSubmit();
    }
  };
  useEffect(() => {
    dispatch(setErrorMessage(""));
  }, []);
  const handleNavBack = () => {
    navigate(-1);
  };

  return (
    <div
      className="SB-modal SB-login-modal SB-modal-fullscreen open"
      id="SB-login-modal"
    >
      <div className="SB-modal-dialog">
        <div className="SB-modal-content">
          <div className="SB-modal-body">
            <div className="SB-loginRegister SB-login">
              <div
                className="SB-loginRegister-innercontainer"
                id="SB-login-af-container"
              >
                <div className="SB-pageHeader">
                  <div
                    className="SB-pageBackButton"
                    id="SB-pageBackBtn"
                    onClick={handleNavBack}
                  >
                    <div className="SB-iconSVG" title="back">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-back`}></use>
                      </svg>
                    </div>
                  </div>
                  <div className="SB-pageHeader-logo">
                    <img src={logoHeader} alt="logo" />
                  </div>
                </div>
                <div className="SB-loginRegister-banner">
                  <div className="SB-loginRegister-discription">
                    <img
                      src={require("../../assets/images/popup/login-TopLeft.webp")}
                      alt="Reload Bonus"
                    />
                  </div>
                  <div className="SB-contentImage">
                    <img
                      src={require("../../assets/images/popup/login-TopRight.webp")}
                      alt="Reload Bonus"
                    />
                  </div>
                </div>
                <div className="SB-loginRegister-content">
                  <div className="SB-loginRegister-promoBanner">
                    <img
                      src={require("../../assets/images/banners/login-reload.gif")}
                      alt="login-banner"
                    />
                  </div>

                  <div className="SB-loginRegister-title">Log In</div>
                  <div className="SB-loginRegister-form">
                    <div className="SB-form-group">
                      <div className="SB-form-label">Mobile Number</div>
                      <div className="SB-form-control-group SB-mobileNumberField">
                        <div className="SB-form-addon SB-addon-left">
                          <div className="SB-regionCode">+254</div>
                        </div>
                        <div
                          className={`SB-form-control ${mobileError ? "SB-error" : ""
                            }`}
                        >
                          <input
                            type={"tel"}
                            placeholder="Enter your mobile number"
                            onKeyPress={(e) => avoidCharacter(e)}
                            onChange={(e) => handleMobileChange(e)}
                            value={mobileNumber}
                            maxLength={numberLength ? 10 : 9}
                          />
                        </div>
                      </div>
                      <div className="SB-form-errorMsg">
                        <span id="">{mobileError}</span>
                      </div>
                    </div>
                    <div className="SB-form-group">
                      <div className="SB-form-label">4 Digit PIN</div>
                      <div className="SB-form-control-group SB-form-control-password">
                        <div
                          className={`SB-form-control ${pinError ? "SB-error" : ""
                            }`}
                          id="userPwdMsgclassNameM"
                        >
                          <input
                            type={hidePassword ? "password" : "text"}
                            id="regPassword"
                            value={pinNumber}
                            placeholder="Enter Your PIN"
                            onChange={handlePinChange}
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                        <div className="SB-form-addon SB-addon-right">
                          <div
                            className={`SB-iconSVG ${!hidePassword ? "d-none" : ""
                              }`}
                            title="password active"
                            id="getShowPwdId"
                            onClick={handleHidePaswword}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="#946969"
                            >
                              <use
                                xlinkHref={`${icons}#${"icon-password-active"}`}
                              />
                            </svg>
                          </div>
                          <div
                            className={`SB-iconSVG ${!hidePassword ? "" : "d-none"
                              }`}
                            title="Password hide"
                            id="getHidePwdId"
                            onClick={handleHidePaswword}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="#946969"
                            >
                              <use xlinkHref={`${icons}#${"icon-password"}`} />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="SB-forgotPinLink-container">
                      <div className="SB-form-errorMsg">
                        <span>{pinError}</span>
                      </div>
                      <Link to="/resetpage">
                        <div
                          className="SB-forgotPinLink"
                          onClick={() => dispatch(setMobileNumber(""))}
                        >
                          Reset PIN?
                        </div>
                      </Link>
                    </div>
                    {errorMessage && (
                      <div className="SB-form-errorMsg text-center">
                        <span>
                          {errorMessage === "INVALID_USER_NAME"
                            ? "User doesn't exist"
                            : errorMessage}
                        </span>
                      </div>
                    )}
                    <div className="text-center">
                      <button
                        className="btn SB-login SB-btnSecondary active SB-btnLarge"
                        id="btnlogin"
                        type="submit"
                        onClick={handleLoginSubmit}
                      >
                        {!isLoading ? (
                          <div className="SB-btnTxt">Login</div>
                        ) : (
                          <div className="SB-loader-container">
                            <div className="SB-loader"></div>
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="SB-loginRegister-navigation">
                    Don't have an account?
                    <Link to="/signup">
                      <span className="SB-txtHightlight">
                        <u>Sign Up</u>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
